/** The receipt fields the AI must be sure of before a receipt counts as read (vendor, total, service period). */
export const RECEIPT_REQUIRED_FIELDS = ['vendor', 'totalGrossCents', 'serviceFrom', 'serviceTo'] as const;

/**
 * Confidence of one field on the 0–1 scale. The prompt asks for 0–1, but models sometimes answer in percent (95):
 * such a value (> 1, ≤ 100) is divided by 100; anything else outside 0–1 or not a number is 0.
 */
export function normaliseConfidence(c: unknown): number {
  if (typeof c !== 'number' || !Number.isFinite(c) || c < 0) return 0;
  if (c <= 1) return c;
  return c <= 100 ? c / 100 : 0;
}

/** The whole confidence map on the 0–1 scale (keys kept). */
export function normaliseConfidenceMap(m: Record<string, unknown> | null | undefined): Record<string, number> {
  return Object.fromEntries(Object.entries(m ?? {}).map(([k, v]) => [k, normaliseConfidence(v)]));
}

/**
 * Confidence shown for a receipt ("95 % sicher"): the lowest confidence of the required fields, 0–1. Optional fields
 * the receipt does not have (invoice number, unit, consumer: null with confidence 0) never pull it down. Null when the
 * AI gave no confidence for any required field.
 */
export function receiptConfidence(m: Record<string, unknown> | null | undefined): number | null {
  const vals = RECEIPT_REQUIRED_FIELDS.filter((k) => m && m[k] != null).map((k) => normaliseConfidence(m![k]));
  return vals.length ? Math.min(...vals) : null;
}
